/** App toaster (sonner) themed dark + a tiny success/error helper (MASTER §6). */
import type { ReactNode } from 'react';
import { toast as sonner, Toaster as SonnerToaster } from 'sonner';

export function Toaster(): ReactNode {
  return (
    <SonnerToaster
      position="top-right"
      theme="dark"
      richColors
      toastOptions={{
        style: {
          background: 'rgb(var(--surface))',
          border: '1px solid rgb(var(--border))',
          color: 'rgb(var(--fg))',
          fontFamily: 'Barlow, system-ui, sans-serif',
        },
      }}
    />
  );
}

export const toast = {
  success: (msg: string, description?: string) => sonner.success(msg, { description }),
  error: (msg: string, description?: string) => sonner.error(msg, { description }),
  info: (msg: string, description?: string) => sonner.info(msg, { description }),
  message: (msg: string, description?: string) => sonner.message(msg, { description }),
};
